<script setup>
import { useSettingForm } from '@/views/Admin/Config/Settings/Common/useSettingForm';
import { onMounted } from 'vue';

const { loading, settings, getData, save } = useSettingForm();

const props = defineProps({
    page: {
        type: String,
        required: true
    },

    settingName: {
        type: String,
        required: true
    }
});

onMounted(() => {
    getData(props.page, props.settingName);
});
</script>

<template>
    <ValidationObserver v-slot="{ invalid }">
        <div style="position: relative">
            <v-overlay
                v-model="loading"
                :absolute="true"
                color="#f3f6f9"
                opacity="0.9"
            >
                <v-container
                    fluid
                    fill-height
                >
                    <v-layout
                        justify-center="true"
                        align-center=""
                    >
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        />
                    </v-layout>
                </v-container>
            </v-overlay>

            <v-card class="SettingCard">
                <v-card-title>
                    <slot
                        v-if="$slots.title"
                        name="title"
                    />

                    <slot
                        v-if="$slots.helpModal"
                        name="helpModal"
                    />
                </v-card-title>

                <v-card-text>
                    <slot
                        v-if="$scopedSlots.settingForm"
                        name="settingForm"
                        :submitFn="save"
                        :settingData="settings"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        v-if="!invalid"
                        :form="page + 'Form'"
                        type="submit"
                        color="primary"
                    >
                        <v-icon
                            small
                            left
                        >
                            fas fa-save
                        </v-icon>
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </ValidationObserver>
</template>

<style lang="scss">

</style>